
class ScrollTopButton {
  constructor(element, ...options) {
    this.defaults = {
      activeClass: '-is-active',
      stopClass: '-is-stopped',
      showBorder: 500,
    };

    this.element = element;
    this.options = Object.assign({}, this.defaults, ...options);

    this.init();
  }

  init() {
    // init everything needed and call methods
    this.bindEvents();
  }

  scrollTop(event) {
    event.preventDefault();
    
    document.querySelector('main').scrollIntoView({ behavior: 'smooth' });
  }

  checkActive() {
    const isActive = this.element.classList.contains(this.options.activeClass);

    if (!isActive && window.pageYOffset > this.options.showBorder) {
      this.element.classList.add(this.options.activeClass);
    } else if (isActive && window.pageYOffset <= this.options.showBorder) {
      this.element.classList.remove(this.options.activeClass);
    }
  }

  checkBottomStop() {
    const footerTop = document.querySelector('footer').getBoundingClientRect().top;

    if (footerTop - window.innerHeight <= 0) {
      this.element.classList.add(this.options.stopClass);
    } else {
      this.element.classList.remove(this.options.stopClass);
    }
  }

  handleScroll() {
    this.checkActive();
    this.checkBottomStop();
  }

  bindEvents() {
    // add event listeners
    this.element.addEventListener('click', this.scrollTop.bind(this));
    document.addEventListener('scroll', this.handleScroll.bind(this));
  }
}
